import React, {Fragment} from "react"
import {Button, Checkbox, DatePicker, Divider, Form, Input, InputNumber, Radio, Select, Typography,} from "antd";

import {EuroOutlined} from "@ant-design/icons"
import {MomentToDate} from "../WebEditor/formPlugins";
import locale_fr from "antd/lib/date-picker/locale/fr_FR";
import DdnField from "../WebEditor/components/DdnField";
import DdnHeField from "../WebEditor/components/DdnHeField";
import { t } from "@lingui/core/macro"
import { Trans } from "@lingui/react/macro"
const {Text}=Typography

export default class ExtraFields  extends React.Component{

    render()
    {
        const {org}=this.props

        const extraFields=org?.web["paiement.extra.fields"] || []

        return(
            <Fragment>

                {extraFields.map(f=>{

                    switch (f.type)
                    {
                        case "PRENOM_HE":
                            return(
                                <Form.Item
                                    label={f.label || t`Prénom Hebraique`}
                                    name={["extra","prenomHE"]}
                                    rules={[{ required: !!f.required, message: t`Ce champ est obligatoire` }]}
                                >
                                    <Input placeholder={f.placeholder || f.label || t`Prénom Hebraique`}/>
                                </Form.Item>
                            )
                        case "DDN":
                            return(
                                <Form.Item
                                    label={f.label || t`Date de naissance`}
                                    name={["extra","ddn"]}
                                    rules={[{ required: !!f.required, message: t`Ce champ est obligatoire` }]}
                                >
                                    <DdnHeField/>
                                </Form.Item>
                            )
                        case "NEWSLETTER":
                            return (
                                <Form.Item
                                    name={["extra","newsletter"]}
                                    rules={[{ required: !!f.required, message: t`Ce champ est obligatoire` }]}
                                    valuePropName={"checked"}
                                >
                                    <Checkbox>{f.placeholder || f.label || t`M'abonner à la Newsletter et être informé du suivi de nos activité`}</Checkbox>
                                </Form.Item>
                            )

                        case "TEXT":
                            return (
                                <Form.Item
                                    label={f.label}
                                    name={["extra","[TEXT]_"+f.name]}
                                    rules={[{ required: !!f.required, message: t`Ce champ est obligatoire` }]}
                                >
                                    <Input placeholder={f.placeholder || f.label}/>
                                </Form.Item>
                            )


                        case "TEXTAREA":
                            return (
                                <Form.Item
                                    label={f.label}
                                    name={["extra","[TEXT]_"+f.name]}
                                    rules={[{ required: !!f.required, message: t`Ce champ est obligatoire` }]}
                                >
                                    <Input.TextArea placeholder={f.placeholder || f.label}/>
                                </Form.Item>
                            )


                        case "SELECT":
                            return (
                                <Form.Item
                                    label={f.label}
                                    name={["extra", "[TEXT]_" + f.name]}
                                    rules={[{ required: !!f.required, message: t`Ce champ est obligatoire` }]}
                                >
                                    <select className={"form-control"}>
                                        <option value={null} disabled selected>{f.placeholder || f.label}</option>
                                        {(f.options || []).map(i => {
                                            const value = i?.value || i
                                            const label = i?.label || value
                                            return (
                                                <option value={value}>{label}</option>
                                            )
                                        })}
                                    </select>
                                </Form.Item>
                            )
                    }

                })}

            </Fragment>
        )
    }
}
